var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 26,
    viewBox: "0 0 54 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 10.3333H14.3333M10.3333 6.33333V14.3333M25 25L17 17M1 10.3333C1 11.559 1.24141 12.7727 1.71046 13.905C2.1795 15.0374 2.86699 16.0663 3.73367 16.933C4.60035 17.7997 5.62925 18.4872 6.76162 18.9562C7.89399 19.4253 9.10766 19.6667 10.3333 19.6667C11.559 19.6667 12.7727 19.4253 13.905 18.9562C15.0374 18.4872 16.0663 17.7997 16.933 16.933C17.7997 16.0663 18.4872 15.0374 18.9562 13.905C19.4253 12.7727 19.6667 11.559 19.6667 10.3333C19.6667 9.10766 19.4253 7.89399 18.9562 6.76162C18.4872 5.62925 17.7997 4.60035 16.933 3.73367C16.0663 2.86699 15.0374 2.1795 13.905 1.71046C12.7727 1.24141 11.559 1 10.3333 1C9.10766 1 7.89399 1.24141 6.76162 1.71046C5.62925 2.1795 4.60035 2.86699 3.73367 3.73367C2.86699 4.60035 2.1795 5.62925 1.71046 6.76162C1.24141 7.89399 1 9.10766 1 10.3333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3333 10.3333H42.3333M53 25L45 17M29 10.3333C29 11.559 29.2414 12.7727 29.7105 13.905C30.1795 15.0374 30.867 16.0663 31.7337 16.933C32.6004 17.7997 33.6292 18.4872 34.7616 18.9562C35.894 19.4253 37.1077 19.6667 38.3333 19.6667C39.559 19.6667 40.7727 19.4253 41.905 18.9562C43.0374 18.4872 44.0663 17.7997 44.933 16.933C45.7997 16.0663 46.4872 15.0374 46.9562 13.905C47.4253 12.7727 47.6667 11.559 47.6667 10.3333C47.6667 9.10766 47.4253 7.89399 46.9562 6.76162C46.4872 5.62925 45.7997 4.60035 44.933 3.73367C44.0663 2.86699 43.0374 2.1795 41.905 1.71046C40.7727 1.24141 39.559 1 38.3333 1C37.1077 1 35.894 1.24141 34.7616 1.71046C33.6292 2.1795 32.6004 2.86699 31.7337 3.73367C30.867 4.60035 30.1795 5.62925 29.7105 6.76162C29.2414 7.89399 29 9.10766 29 10.3333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.70f4d59d918dc6214d84e7e0a18219ec.svg";
export { ForwardRef as ReactComponent };